const isPack = (prepackList) => {
  return !!prepackList?.length
}
const getSizeInfo = (sizeCode, sizeList) => {
  return sizeList?.length ? sizeList?.toString().replaceAll(',', ' | ') : sizeCode
}
const getPackInfo = (sizeList, prepackList) => {
  const size = sizeList?.toString().replaceAll(',', ' / ')
  const prepack = prepackList?.toString().replaceAll(',', ' / ')
  return `${prepack} (${size})`
}
const getSumOfPack = (prepackList) => {
  return prepackList?.reduce((a, b) => parseInt(a) + parseInt(b), 0)
}
const getPackQty = (prepackList, qtyList) => {
  let minPackQty = Infinity
  for (let idx = 0; idx < prepackList.length; idx++) {
    if (qtyList[idx] === 0) {
      return 0
    }
    const tempPackQty = Math.floor(qtyList[idx] / prepackList[idx])
    minPackQty = Math.min(minPackQty, tempPackQty)
  }
  return minPackQty === Infinity ? 0 : minPackQty
}
const getFinalUnitPrice = (priceByColor, baseProduct, mockupOption) => {
  const basePrice = getUnitPrice(priceByColor, baseProduct, mockupOption.basePriceLevel)
  const specialPrice = getUnitSpecialPrice(priceByColor, baseProduct, mockupOption.specialPriceLevel)
  if (specialPrice && basePrice > specialPrice) return g.decimalNumber(specialPrice, 2)
  if (specialPrice && basePrice < specialPrice) return g.decimalNumber(specialPrice, 2)
  return g.decimalNumber(basePrice, 2)
}
const getUnitPrice = (priceByColor, baseProduct, basePriceLevel, isWithStyle = false) => {
  const basePrice = priceByColor ? _getPriceByPriceLevel(priceByColor, basePriceLevel) : baseProduct.price
  return isWithStyle ? g.currencyUSD(basePrice, true) : basePrice
}
const getUnitSpecialPrice = (priceByColor, baseProduct, specialPriceLevel, isWithStyle = false) => {
  const specialPrice = priceByColor ? _getPriceByPriceLevel(priceByColor, specialPriceLevel) : baseProduct.specialPrice
  return isWithStyle ? g.currencyUSD(specialPrice, true) : specialPrice
}
const _getPriceByPriceLevel = (priceByColor, priceLevel) => {
  let price
  switch (priceLevel) {
    case '':
      price = null
      break
    case 'P1':
      price = priceByColor.price1
      break
    case 'P2':
      price = priceByColor.price2
      break
    case 'P3':
      price = priceByColor.price3
      break
    case 'P4':
      price = priceByColor.price4
      break
    case 'P5':
      price = priceByColor.price5
      break
    case 'MSRP':
      price = priceByColor.msrp
      break
    case 'MAX':
      price = Math.max(
        priceByColor.price1,
        priceByColor.price2,
        priceByColor.price3,
        priceByColor.price4,
        priceByColor.price5
      )
      break
  }
  return price
}
const getFirstImageFileName = (images) => {
  return images[0]?.imageFileName
}
const getIdxByArrayKey = (list, keyToFind) => {
  return list.indexOf(keyToFind)
}

const getMsrp = (priceByColor, baseProduct, isWithStyle = false) => {
  const msrp = priceByColor ? priceByColor.msrp : baseProduct.msrp
  return isWithStyle ? g.currencyUSD(msrp, true) : msrp
}

// FOR JOVANI
const getColorName = (product, colorCode) => {
  return product?.colorDescByCode[colorCode]
}
const getStyleColorKey = (item) => `${item.style}|${item.color}`
const getStyleColorSizeKey = (item, sizeName) => `${getStyleColorKey(item)}|${sizeName}`

export const p = {
  isPack,
  getSizeInfo,
  getPackInfo,
  getSumOfPack,
  getPackQty,
  getIdxByArrayKey,
  getFinalUnitPrice,
  getUnitPrice,
  getUnitSpecialPrice,
  getMsrp,
  getFirstImageFileName,
  getColorName,
  getStyleColorKey,
  getStyleColorSizeKey
}
